__turbopack_context__.v({
  "activeLanguage": "Header-module__arFiJq__activeLanguage",
  "language": "Header-module__arFiJq__language",
  "languageButton": "Header-module__arFiJq__languageButton",
  "languageDivider": "Header-module__arFiJq__languageDivider",
  "skiplink": "Header-module__arFiJq__skiplink",
});
